import React from 'react';
import { cn } from '@pulsex/utils';
import Link from 'next/link';
import { RightSign } from '@/icons/RightSign';
import { locale } from '@/locale';
import DoubleQuotationIcon from '@/icons/DoubleQuotationIcon';

type TabsProps = {
    showMore?: boolean;
    showTabs?: boolean;
    type?: 'dark';
    className?: string;
    title?: string;
    largeIconSize?: number;
    customTitle?: string;
    moreUrl?: string | undefined;
    tabsArray?: { title: string; url: string }[];
    colorTheme?: string;
    isMobile?: boolean;
    showMobileMoreBtn?: any;
    showLine?: boolean;
    quoteClassName?: string;
    /** Page chrome titles use h1; section/aside titles stay h2 (default). */
    as?: 'h1' | 'h2';
};

const moreTab = {
    url: '',
    title: '',
};

export const TitleSection = ({
    showMore = true,
    showTabs = true,
    className,
    title,
    type,
    largeIconSize = 30,
    customTitle,
    colorTheme,
    moreUrl,
    tabsArray = [],
    isMobile = false,
    showMobileMoreBtn,
    showLine = true,
    quoteClassName,
    as: HeadingTag = 'h2',
}: TabsProps) => {
    const getTabs = (): { title: string; url: string }[] => {
        if (showTabs && tabsArray.length) {
            return [...tabsArray];
        } else if (showMore && moreUrl && !showTabs) {
            return [moreTab];
        } else if (showMore && showTabs && tabsArray.length) {
            return moreUrl ? [...tabsArray, moreTab] : [...tabsArray];
        }
        return [];
    };

    return (
        <>
            <div className={cn('flex items-center w-full pb-5 lg:pb-6', className)}>
                <DoubleQuotationIcon
                    size={isMobile ? 20 : largeIconSize}
                    className={cn('fill-masterRed ml-1.5', quoteClassName)}
                />

                <HeadingTag
                    className={cn(
                        'text-3xl lg:text-4xl maxcursor-pointer text-[#242424] font-semibold ',
                        type === 'dark' && 'text-white',
                        customTitle
                    )}
                    style={{ color: colorTheme }}
                >
                    {moreUrl ? (
                        <Link href={moreUrl || ''}>
                            {title || (tabsArray?.length ? tabsArray[0]?.title : '')}
                        </Link>
                    ) : (
                        title || (tabsArray?.length ? tabsArray[0]?.title : '')
                    )}
                </HeadingTag>
                {showLine && <div className="flex-grow border-t border-[#242424] mr-3 lg:mr-5" />}
            </div>
        </>
    );
};
